// Components
import DadosBasicos from "./components/DadosBasicos";
import MinhasReservas from "./components/MinhasReservas";

// hooks
import React from "react";
import { hooks } from "../../utils";
import { api } from "../../services";
import { StorageContext } from "../../contexts/StorageContext";

// Styles
import Styles from "./styles";

// Types
export interface TelasProp {
  nome: string;
  component: JSX.Element;
}

export interface OwnersProps {
  id: string;
  email: string;
  name: string;
  cpf: string;
  places: {
    externalId: string;
    id: string;
    name: string;
  }[];
}

// Constantes

const PAGE_SIZE = 8; 

function MeusDados() {
  // States
    const [telaAtiva, setTelaAtiva] = React.useState<number>(0);
    const [placeList, setPlaceList] = React.useState<any>([]);
    const [ownersList, setOwnersList] = React.useState<{
        content: OwnersProps[];
        totalPages: number;
    } | null>(null);
    const [ownerData, setOwnerData] = React.useState<OwnersProps | null>(null);
    const [totalPages, setTotalPages] = React.useState(0);
    const [filters, setFilters] = React.useState<any>(null);

  // Hooks
  const { call } = hooks.useRequest();
  const { userData } = React.useContext<any>(StorageContext);

  // Chamada API
    const Mount = React.useCallback(() => {
        call(
            null,
            api.getPlaces({
                page: 0,
                size: 999999,
            }),
            async (response) => {
                if (response.ok) {
                    const list = response?.data?.content.map((item) => {
                        return { label: item.name, value: item.id, user: item.user };
                    });

                    setPlaceList(list);
                }
            }
        );
        filterOwners({}, 0);
    }, []);

    React.useEffect(() => {
        Mount();
    }, [Mount]);

    const filterOwners = (
        filterData?: {
          fullName?: string;
          email?: string;
          cpf?: string;
        },
        page?: number
      ) => {
        let filters = {
          page: page ? page : 0,
          size: PAGE_SIZE,
        };
        if (filterData?.fullName) {
          filters["name"] = filterData.fullName;
        }
        if (filterData?.email) {
          filters["email"] = filterData.email;
        }
        if (filterData?.cpf) {
          filters["cpf"] = filterData.cpf;
        }
    
        call(null, api.getOwners(filters), async (response) => {
          if (response.ok) {
            setOwnersList(response.data);
            setTotalPages(page ? page : 0);
            setFilters(filterData);

            response.data.content.forEach((owner) => {
              if (owner.id === userData.id) {
                setOwnerData(owner);
              }
            });
          }
        });
      };

    // Telas
    const telas: TelasProp[] = [
        { nome: "Dados Básicos", component: <DadosBasicos ownerData={ownerData} /> },
        { nome: "Minhas Reservas", component: <MinhasReservas /> },
    ];

  return (
    <Styles.containerGeral>
      <Styles.SelectorContainer>
        {telas.map((tela, index) => (
          <Styles.SelectorButton
            key={tela.nome}
            onClick={() => setTelaAtiva(index)}
            disabled={telaAtiva === index}
          >
            {tela.nome}
          </Styles.SelectorButton>
        ))}
      </Styles.SelectorContainer>
      {telas[telaAtiva]?.component}
    </Styles.containerGeral>
  );
}

export default MeusDados;
